import React, { useState } from 'react';
import styles from './sections.module.css';
import { publicSiteAPI } from '../../../services/api';

interface NewsletterSectionProps {
  newsletter: any;
  slug: string;
}

export const NewsletterSection: React.FC<NewsletterSectionProps> = ({ newsletter, slug }) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    try {
      await publicSiteAPI.subscribeNewsletter(slug, email);
      setSubmitted(true);
      setEmail('');
    } catch {
      // silent
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="newsletter" className={`${styles.section} ${styles.newsletterBg}`}>
      <div className={styles.container}>
        <div className={styles.newsletterContent}>
          <h2 className={styles.sectionTitle}>{newsletter?.heading || 'Blijf op de hoogte'}</h2>
          {newsletter?.description && <p className={styles.sectionSubtitle}>{newsletter.description}</p>}
          {submitted ? (
            <p className={styles.newsletterSuccess}>Bedankt voor uw aanmelding!</p>
          ) : (
            <form onSubmit={handleSubmit} className={styles.newsletterForm}>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Uw e-mailadres"
                required
                className={styles.newsletterInput}
              />
              <button type="submit" className={styles.formButton} disabled={sending}>
                {sending ? 'Aanmelden...' : 'Aanmelden'}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
